module.exports = require("jose");